import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpUtils } from '../common/http-utils';
import { Toast } from '../common/toast';
import { Constants } from '../common/constants';
import { LocalStorage } from '../common/local-storage';
import { Tags } from '../common/tags';
import { LoaderService } from '../common/loader-service';
import { SimpleModalService } from 'ngx-simple-modal';
import { Utils } from '../common/utils';
import { environment } from 'src/environments/environment';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { HttpClient } from '@angular/common/http';
import { GUI } from '../common/gui';
import { Route } from '../common/route';
import { MemoryStorage } from '../common/memory-storage';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  private encryptedApplicantId: string = this.constants.BLANK;

  private encryptedPaymentType: string = this.constants.BLANK;

  private encryptedContactlessEligibility: string = this.constants.BLANK;


  applicantId: string = this.constants.BLANK;

  contactlessEligibility: string = this.constants.BLANK;
  private paymentType: string = this.constants.BLANK;
  selectedPaymentMode: string = this.constants.BLANK

  isPayButtonDisabled: boolean = false;
  private isSubmitForm: number = this.constants.FALSE;

  gatewayDetailsList: any = [];

  paymentFormObject: any = {};

  referenceLabel: string = "Reference Number";

  applicationPaymentDetailsObject: any = {};

  private paymentPostForm: HTMLFormElement;


  constructor(private http: HttpClient, private router: Router, private route: Route, private ngZone: NgZone, private activatedRoute: ActivatedRoute, private httpUtils: HttpUtils, public constants: Constants,
    private loaderService: LoaderService, private toast: Toast, public utils: Utils, private readonly keycloakService: KeycloakService, private browserStorageService: MemoryStorage, private localStorage: LocalStorage, private tags: Tags, private gui: GUI) {
    activatedRoute.params.subscribe((params: Params) => {
      this.encryptedApplicantId = params['applicantId'];
      this.encryptedPaymentType = params['paymentType'];
      this.encryptedContactlessEligibility = params['contactlessEligibility'];
    });

    activatedRoute.queryParams.subscribe((params: Params) => {

      this.encryptedContactlessEligibility = params['contactlessEligibility'];
    });
    this.applicantId = this.utils.decryptString(this.encryptedApplicantId);
    this.paymentType = this.utils.decryptString(this.encryptedPaymentType);
    this.contactlessEligibility = this.utils.decryptString(this.encryptedContactlessEligibility);
    this.storeApplicationPaymentDetailsV2();



  }

  ngOnInit(): void {
  }

  // Add these to your component.ts
  trackByGateway(index: number, gateway: any): string {
    return gateway.id || index;
  }

  onPaymentMethodChange(gateway: any): void {
    this.isPayButtonDisabled = false;
    this.selectedPaymentMode = gateway?.gatewayName;
    // Set transaction fee if needed
    // if (gateway.transactionFee) {
    // this.paymentFormObject.paymentMode = this.selectedPaymentMode;
    // }

    // Handle any other logic
    console.log('Selected gateway:', gateway);
  }

  getGatewayImage(gatewayName: string): string {
    const images = {
      'HYDROGENPAY': 'assets/images/hydrogenpay-logo.png',
      'PAYSTACK': 'assets/images/paystack-logo.png'
    };

    return images[gatewayName.toUpperCase()] || 'assets/images/default-gateway-logo.png';
  }
  // onPaymentMethodChange(method: any): void {
  //   this.setTransactionFee();
  //   this.setIsSubmitForm(method.isSubmitReq);
  // }


  private storeApplicationPaymentDetailsV2(): void {
    this.loaderService.startLoader();
    this.httpUtils.fetchApplicationPaymentDetailsV2(this.applicantId, this.constants.APPLICATION_PAYMENT, this.contactlessEligibility).then(serverResponse => {
      this.loaderService.stopLoader();
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        const serverFeeChangedMsg = serverResponse.feeChangedMsg;
        if (this.utils.isEmpty(serverFeeChangedMsg) === false) {
          this.isPayButtonDisabled = true;
          this.toast.showErrorToastWithCallbackFunction(serverFeeChangedMsg, this.openApplicationAddEditPage.bind(this, this.ngZone, this.router, this.encryptedApplicantId));
          return;
        }
        this.applicationPaymentDetailsObject = serverResponse;
        this.applicationPaymentDetailsObject.transactionFee = 0;
        this.applicationPaymentDetailsObject.totalFeeIncludeServiceFee = this.applicationPaymentDetailsObject.totalFee;
        this.gatewayDetailsList = serverResponse.gatewayDetails;
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }

  private openApplicationAddEditPage(ngZone: NgZone, router: Router, encryptedApplicantId: string): void {
    ngZone.run(() => router.navigate([this.route.APPLICATION_ADD_EDIT, encryptedApplicantId]));
  }


  backToApplicationView(): void {
    // if(this.paymentType === this.constants.APPLICATION_PAYMENT) {
    //   this.gui.openApplicationView(this.applicationPaymentDetailsObject.applicantId, this.constants.KIN_INFO_STAGE);
    // } else {
    //   this.gui.openCODView(this.applicationPaymentDetailsObject.referenceNumber);
    // }
  }

  setIsSubmitForm(isSubmitForm: number): void {
    this.isSubmitForm = isSubmitForm;
  }
  async makePayment(): Promise<void> {
    this.loaderService.startLoader();

    try {
      const formData = this.createPaymentFormData();
      const paymentUrl = await this.processPayment(formData);

      if (paymentUrl) {
        this.redirectToPaymentGateway(paymentUrl);
        this.toast.showSuccessToast("Processing payment, please wait...");
      } else {
        throw new Error('No payment URL received');
      }

    } catch (error) {
      let errorMessage = 'Payment failed, Please try again later';

      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else if (error?.responseMsg) {
        errorMessage = error.responseMsg;
      }

      this.toast.showErrorToast(errorMessage);
      this.handlePaymentError(error);
    } finally {
      this.loaderService.stopLoader();
    }
  }

  private createPaymentFormData(): FormData {
    const formData = new FormData();
    formData.append('applicationId', this.applicationPaymentDetailsObject.applicationId);
    formData.append('paymentMode', this.selectedPaymentMode);
    formData.append('paymentType', this.constants.APPLICATION_PAYMENT);
    formData.append('authToken', this.localStorage.getStorageKey(this.tags.APPLICATION_TOKEN));
    return formData;
  }

  private async processPayment(formData: FormData): Promise<string> {
    try {
      this.saveAuthToken();
      const response: any = await this.http.post<PaymentResponse>(
        `${environment.serverBaseUrl}v1/payments/makePayment`,
        formData
      ).toPromise();

      const paymentUrl = response?.data?.authorization_url || response?.data?.url;

      if (!paymentUrl) {
        this.toast.showErrorToast(response.responseMsg || 'No valid payment URL found in response');
        throw new Error(response?.responseMsg || 'No valid payment URL found in response');
      }

      return paymentUrl;
    } catch (error) {
      if (error?.error?.responseMsg) {
        this.toast.showErrorToast(error.error.responseMsg || 'No valid payment URL found in response');
        throw new Error(error.error.responseMsg);
      }
      throw error;
    }
  }

  private redirectToPaymentGateway(url: string): void {
    window.location.href = url;
  }

  private handlePaymentError(error: any): void {
    console.error('Payment failed:', error);

  }

  private saveAuthToken(): void {
    const authorizationWithKey = true;
    const encryptedAuthorizationWithKey = this.utils.encryptString(
      authorizationWithKey.toString()
    );

    this.localStorage.setSessionStorageKey(this.tags.APPLICATION_TOKEN, this.browserStorageService.get(this.tags.APPLICATION_TOKEN));
    this.localStorage.setSessionStorageKey(this.tags.AUTHORIZATION, encryptedAuthorizationWithKey);
    this.localStorage.setSessionStorageKey(this.tags.SERVER_APPLICATION_TOKEN, this.browserStorageService.get(this.tags.SERVER_APPLICATION_TOKEN));
    this.localStorage.setSessionStorageKey(this.tags.KEYCLOAK_TOKEN, this.keycloakService.getKeycloakInstance().token);
    this.localStorage.setSessionStorageKey(this.tags.LOGGED_USER_ID, this.browserStorageService.get(this.tags.LOGGED_USER_ID));
    this.localStorage.setSessionStorageKey(this.tags.LOGGED_USER_NAME, this.browserStorageService.get(this.tags.LOGGED_USER_NAME));

  }
}
